import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getFormattedLanguageId, getLocalisationData } from './utils/globals';
import { NODE_ENV } from './utils/config';
const langId = getFormattedLanguageId();
i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
    resources: {
        [langId]: { translation: getLocalisationData() },
    },
    lng: langId,
    interpolation: {
        escapeValue: false, // react already safes from xss
    },
    debug: NODE_ENV === 'production',
});
export default i18n;
//# sourceMappingURL=i18n.js.map